// link-fixes.js
// Ensure any links pointing to /blog route to /digest instead
(function () {
  function rewriteBlogLinks() {
    var anchors = document.querySelectorAll('a[href]');
    var origin = window.location.origin;
    anchors.forEach(function (a) {
      try {
        var href = a.getAttribute('href');
        if (!href) return;
        // Leave in-page anchors alone ("#the-film" must not become "/#the-film").
        if (href.charAt(0) === '#') return;
        // Ignore external protocols
        if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

        // Build a URL object safely (handles relative and absolute)
        var url;
        try {
          url = new URL(href, origin);
        } catch (e) {
          return; // invalid URL
        }

        // Only rewrite same-origin links
        if (url.origin !== origin) return;

        // Only touch /blog links: rewrite them to /digest. Every other link
        // keeps its original href untouched.
        if (url.pathname === '/blog' || url.pathname === '/blog/') {
          url.pathname = '/digest/';
        } else if (url.pathname.indexOf('/blog/') === 0) {
          url.pathname = url.pathname.replace('/blog/', '/digest/');
        } else {
          return;
        }
        a.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {
        // no-op
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteBlogLinks);
  } else {
    rewriteBlogLinks();
  }
})();
